import React from 'react';
import { ReactComponent as ShieldSignupLeftpanel } from '../../../assets/svg/signup/shield-signup-leftpanel.svg';
import { Grid } from '@mui/material';
/**
 * Author : Shivaraj PP
 * Component : LeftPanelWithOverlay
 * Description : Left panel with overlay component used in signup and Onboarding pages
 */
interface Feature {
  icon: React.ReactNode;
  title: string;
  description: string;
}

interface LeftPanelWithOverlayProps {
  features: Feature[];
  type:string;
}

const LeftPanelWithOverlay: React.FC<LeftPanelWithOverlayProps> = ({ features,type }) => (
<Grid className={`left-panel`}>
    <div className="left-panel-content">
      <h1 className="left-panel-title">
        Supercharge your funds flow with Passport
      </h1>
      <div className="left-panel-features">
        {features.map((feature, index) => (
          <div key={index} className="left-panel-feature">
            <div className="left-panel-icon">{feature.icon}</div>
            <div>
              <h2 className="left-panel-feature-title">{feature.title}</h2>
              <p className="left-panel-feature-description">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
      <Grid className="left-panel-privacy-signup" marginTop="7.33rem">
        <ShieldSignupLeftpanel />
        <p>Your privacy matters to us. Your information is securely stored and encrypted.</p>
      </Grid>
    </div>
  </Grid>
);

export default LeftPanelWithOverlay;